import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import "./App.css";
import "./index.css";
import "./custom.css";
import "./Custom-sweet-alert.css";

import { FailurePayment } from "./components/PaymentResponse/FailurePayment";
import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import PaymentPlans from "./components/PaymentPlan";
import PaymentHistory from "./components/PaymentHistory/PaymentHistory";
import Profile from "./components/Profile";
import Payments from "./components/Payments";
import DashboardLayout from "./components/DashboardLayout";

// Public pages
import Home from "./components/Home/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Services from "./components/Services/Service";
import Contact from "./components/Contact/Contact";
import FrequentlyAskedQuestion from "./components/FrequentlyAskedQuestions/FrequentlyAskedQuestion";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Legal from "./components/Legal/Legal";
import RefundPolicy from "./components/RefundPolicy/RefundPolicy";
import SmsPolicy from "./components/SmsPolicy/SmsPolicy";
import CredenceResponsible from "./components/CredenceResponsible/CredenceResponsible";
// Auth and other pages
import Login from "./components/Login/Login";
import SuccessfulPayment from "./components/PaymentResponse/SuccessfulPayment";
import NotFound from "./components/NoPage/NoPage";

import PublicLayout from "./components/PublicLayout";

function App() {
  return (
    <Router>
      <Routes>
        {/* Home route without navbar */}
        <Route path="/" element={<Home />} />

  
        <Route
          element={<PublicLayout />}
        >
          <Route path="/About-Us" element={<AboutUs />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Contact-Us" element={<Contact />} />
          <Route path="/FAQ" element={<FrequentlyAskedQuestion />} />
          <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
          <Route path="/Legal" element={<Legal />} />
          <Route path="/Sms-Policy" element={<SmsPolicy />} />
          <Route path="/Refund-Policy" element={<RefundPolicy />} />
           <Route path="/Credence-Responsible-Vulnerability-Disclosure" element={<CredenceResponsible />} />
        </Route>

        {/* Authentication routes */}
        <Route path="/Pay" element={<Login />} />
        <Route path="/FailurePayment" element={<FailurePayment />} />

        {/* Dashboard routes */}
        <Route element={<DashboardLayout />}>
          <Route path="/SuccessfulPayment" element={<SuccessfulPayment />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/PaymentPlan" element={<PaymentPlans />} />
            <Route path="/PaymentHistory" element={<PaymentHistory />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/Payment" element={<Payments />} />
          </Route>
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;